import { HiddenVisually, Text } from "@bookingcom/bui-react";
import NoSSR from "app/NoSSR";
import React, { ReactNode } from "react";
import flights_web_reduce_spacing_sr_ddot from "utils/experiments/funnel/flights_web_reduce_spacing_sr_ddot";
import { Sidebar } from "../Container";
import { DSATraceabilityPopover } from "../FlightDetailsInner/components/DSATraceability";
import Frame from "../Frame";
import SearchFiltersDesktop from "../SearchFilters/SearchFilters.desktop";
import SearchFiltersSummary from "../SearchFiltersSummary";
import AiSummaryDesktop from "./components/AiSummary.desktop";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { DESKTOP_SIDEBAR_WIDTH } from "../../../constants";
import SearchTabs from "../SearchTabs";
import styles from "./SearchResults.desktop.module.css";
import flights_split_bounds_us from "utils/experiments/funnel/flights_split_bounds_us";

type Props = {
  children: React.ReactNode;
  banners?: ReactNode;
  shouldMoveBudgetFilter?: boolean;
  showGenAiSummary?: boolean;
};

// Temp fix for carousel increasing width
const attributes = { style: { width: `calc(100% - ${DESKTOP_SIDEBAR_WIDTH}px)` } };

const SearchResultsWrapperDesktop = ({
  children,
  banners,
  shouldMoveBudgetFilter,
  showGenAiSummary = false
}: Props) => {
  const i18n = useI18n();

  return (
    <div className={styles.searchResults} data-testid="searchresults_list">
      <NoSSR>
        <Frame direction="row">
          <Sidebar fixScrollPadding pt={flights_web_reduce_spacing_sr_ddot.trackWithDefaultStage() ? 0 : 4}>
            {showGenAiSummary && <AiSummaryDesktop />}

            <Frame pb={3}>
              <SearchFiltersSummary />
            </Frame>
            <SearchFiltersDesktop shouldMoveBudgetFilter={shouldMoveBudgetFilter} />
            <DSATraceabilityPopover />
          </Sidebar>

          <Frame
            direction="column"
            grow={1}
            pt={flights_web_reduce_spacing_sr_ddot.trackWithDefaultStage() ? 0 : 4}
            pb={4}
            pl={6}
            attributes={attributes}
          >
            <HiddenVisually>
              <Text tagName="h2">{i18n.trans(t("a11y_flights_sr__results_hidden_heading"))}</Text>
            </HiddenVisually>
            {banners}
            {flights_split_bounds_us.trackWithDefaultStage() ? (
              children
            ) : (
              <SearchTabs showBestRankingInfo={true}>{children}</SearchTabs>
            )}
          </Frame>
        </Frame>
      </NoSSR>
    </div>
  );
};

export default React.memo(SearchResultsWrapperDesktop);
